import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import { Text, getPaletteColor } from 'pcln-design-system'

/** = Styles */
const StyledSavings = styled(Text.p)`
  color: ${getPaletteColor('border.dark')};
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
`

export default function SavingsPercentage(props) {
  const { savings } = props
  const THRESHOLD = 1
  if (!savings || !savings.inPercent || savings.inPercent < THRESHOLD) {
    return null
  }

  return <StyledSavings data-testid='savings'>{`Save ${savings.inPercent}%`}</StyledSavings>
}

SavingsPercentage.propTypes = {
  savings: PropTypes.shape({
    inDollars: PropTypes.number,
    inPercent: PropTypes.number,
  }),
}
